import { Platform } from 'react-native';
import { Badge, BadgeText } from "@/components/ui/badge";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { HStack } from "@/components/ui/hstack";
import { View } from "@/components/ui/view";
import React from 'react';
import { useSelector } from 'react-redux';
import ImageSynced from '../media/ImageSynced';
import { isMedia, isVideo } from '../media/MediaSelector';
import SvgOverlay from '../media/SvgOverlay';
import { IconM } from '../media/IconsV2';
import MediaDraw from '../media/MediaDraw';
import RichText from "./RichText";

export default function BasicElement({ media, overlay, sync, prefix, title, text, disabled, mark1, mark2, graph, tag, children }) {

    const imgLoad = useSelector((state) => state.images.load)
    const preview = useSelector((state) => state.temp?.preview || false)

    return (
        <View className="flex-row my-2 w-full">
            <HStack space='sm' className="w-[85%]">
                <View className="h-[64px] w-[64px]">
                    {preview && graph ?
                        <SvgOverlay key={Math.random()} graph={graph} />
                        : <>
                            {isMedia(media) ?
                                <IconM size={60} className='text-primary-900' name={isVideo(media) ? 'videocam' : 'audiotrack'} />
                                :
                                <>
                                    <ImageSynced key={media + '_' + imgLoad[media]?.duration} uri={media} sync={sync} className="w-full h-full" />
                                    {overlay && <MediaDraw size={64} overlay={overlay} />}
                                </>}
                            <View className={` ${mark1 ? "w-2" : "w-0"} absolute left-0 bg-primary-900 h-[64px] `} />
                            <View className={` ${mark2 ? "w-2" : "w-0"} ${mark1 ? "left-2" : "left-0"} absolute bg-primary-700 h-[64px] `} />
                        </>
                    }
                </View>
                <VStack className={` ${graph ? "pl-2" : "pl-0"} self-center w-[80%] pr-5`}>
                    <Text bold className={` text-secondary-900 text-xl line-clamp-1`}>
                        <Text bold className={` text-primary-900 text-xl`}>{prefix}</Text>
                        <Text bold className={` text-secondary-900 text-xl`}>{title}</Text>
                    </Text>
                    {Platform.OS !== 'web' ?
                    <RichText flat text={text} className={` text-secondary-900 text-lg`} /> : 
                    <Text className="text-secondary-900 text-lg line-clamp-2">{text}</Text> }
                </VStack >
            </HStack>
            <VStack className="w-[15%] self-center">
                {children}
            </VStack>
            {tag && <Badge className="absolute ml-[50px] top-0 bg-ina-blue rounded-full">
                <BadgeText className="text-secondary-50">{tag}</BadgeText>
            </Badge>}
            {disabled && <View className="absolute left-0 bg-white opacity-60 h-[100%] w-[100%]" />}
        </View>
    );
}
